export default __webpack_public_path__ + "images/SpeakersPhotos/Fernando_Garcia_BHub.jpg?0ccdf098";